import React from 'react';
import { Card, Typography, Box } from '@mui/material';
import { IconHeartbeat } from '@tabler/icons-react';
import { styled } from '@mui/material/styles';
import { t } from 'i18next';
import dayjs from 'dayjs';

const StyledIconHeartbeat = styled(IconHeartbeat)(() => ({
    width: '100px',
    height: '100px'
}));

const StressTestCard = ({
    type,
    date,
    data,
    duration,
    selected,
    compareMode,
    isLatest,
    onClick
}) => {
    const isHighlighted = compareMode ? selected : isLatest;

    const bgColor = isHighlighted ? '#0A579B' : '#ffffff';
    const textColor = isHighlighted ? '#ffffff' : '#0A579B';
    const borderColor = '#0A579B';

    const formattedDate = dayjs(date).format('DD/MM/YYYY');

    const protocol = data?.results?.Protocolo;

    const getStressTestTitle = (type, t) => {
        switch (type) {
            case 'STRESS_TEST':
                return t('stress.title2');
            case 'STRESS_TEST_CP':
                return t('stress.title3');
            default:
                return t('stress.title2');
        }
    };

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') onClick();
            }}
            style={{ cursor: 'pointer' }}
        >
            <Card
                elevation={0}
                sx={{
                    display: 'flex',
                    backgroundColor: bgColor,
                    boxShadow: 'none',
                    border: `2px solid ${borderColor}`,
                    cursor: 'pointer',
                    opacity: compareMode && !selected ? 0.6 : 1,
                    transition: '0.2s ease-in-out',
                    '&:hover': {
                        boxShadow: 6,
                        transform: 'scale(1.02)',
                        transition: '0.2s ease-in-out'
                    }
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px'
                    }}
                >
                    <StyledIconHeartbeat
                        style={{
                            color: textColor
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        flex: 'auto',
                        flexDirection: 'column',
                        alignContent: 'flex-start',
                        justifyContent: 'space-around',
                        padding: '10px'
                    }}
                >
                    <Typography component="div" variant="h2" sx={{ color: textColor }}>
                        {getStressTestTitle(type, t)}
                    </Typography>

                    <Typography component="div" variant="h5" sx={{ color: textColor }}>
                        {formattedDate}
                    </Typography>

                    <Typography component="div" variant="h5" sx={{ color: textColor }}>
                        {t('stress.protocol')}: {protocol ?? '—'}
                    </Typography>

                    <Typography component="div" variant="h5" sx={{ color: textColor }}>
                        {t('stress.duration')}: {duration} min
                    </Typography>
                </Box>
            </Card>
        </div>
    );
};

export default StressTestCard;
